<template>
  <Select style="max-width: 350px;" :transfer="true" :value="value" @on-change="handleChange">
    <Option v-for="item in values" :value="item.value" :label="item.label" :key="item.value" :disabled="!!item.disabled">
      <span>{{ item.label }}</span>
      <span v-if="item.placeholder" style="float:right;color:#ccc">{{item.placeholder}}</span>
    </Option>
  </Select>
</template>
<script>
export default {
  props: {
    field: {
      type: String
    },
    values: {
      type: Array
    },
    value: {}
  },

  methods: {
    handleChange(v) {
      let hit = this.values.find(i => i.value == v)
      if (hit) {
        this.$emit('change', this.field, v, hit.label)
      }
    }
  }
}

</script>
